/* eslint-disable */
/*
* hotels.js
*
* Description: Holds 'Stores' Logic for Module:'Hotels'.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew - Hotels"
* Copyright 2018,2019,2020 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';

import { eventBus } from '../../../main';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> hotels -----------------------------------------
    hotels_hotels: [],
    hotels_hotels_Filtered: [],

    // >>> Hotel Goodies ----------------------------------
    hotel_HotelGoodies: [],

    // >>> hotels search/filter----------------------------
    hotels_filterTerm: "",
    hotels_searchTerms: {
        "country": '',
        "city": '',
        "shuttle": [true, false],
        "associatedAirport": '',
        "status": [true],
        "minHotelCost": '',
        "maxHotelCost": ''
    },

};


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Hotels' - Load Hotels(s)
    ***************************************************************************/
    /***************************************************************************
    * get_Hotels()
    *
    * Desc:
    * Note:
    *
    */
    get_Hotels: state => {

        return state.hotels_hotels;

    }, // eof get_Hotels()


    /***************************************************************************
    * get_Hotels_Filtered()
    *
    * Desc:
    * Note:
    *
    */
    get_Hotels_Filtered: state => {

        return state.hotels_hotels_Filtered;

    }, // eof get_Hotels_Filtered()




    /***************************************************************************
    * Getters: 'Hotels' - Load Hotels(s)
    ***************************************************************************/
    /***************************************************************************
    * get_HotelGoodies()
    *
    * Desc: Return Hotel Goodies from Backend.
    * Note:
    *
    */
    get_HotelGoodies: state => {

        return state.hotel_HotelGoodies;

    }, // eof get_HotelGoodies()

};


//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'Hotels' - Hotels
    ***************************************************************************/
    /***************************************************************************
    * mut_set_Hotels()
    *
    * Desc: Simply set 'hotels_hotels'.
    * Note: Set filtered Version here too.
    *
    */
    mut_set_Hotels: (state, payload) => {

        state.hotels_hotels = payload.response;
        state.hotels_hotels_Filtered = payload.response;

        payload.context.commit('mut_filter_Hotels');

    }, // eof mut_set_Hotels()




    /***************************************************************************
    * Mutations: 'Hotels' - Update/Create
    ***************************************************************************/
    /***************************************************************************
    * mut_call_updateCreateHotel()
    *
    * Desc: Update or Create in 'hotels_hotels'.
    * Note: Build 'filterableName'.
    * Note: 'editorMode' decides if we have to 'update' or to 'create' (add).
    * Note: { response: response.data, editorMode: payload.editorMode }
    *
    */
    mut_call_updateCreateHotel: (state, payload) => {

        let item = null,
            hotels_hotels_Copy = [];


        if (payload.editorMode === 'update') {
            state.hotels_hotels.forEach((item) => {
                if (item.id === payload.response.id) {
                    item = payload.response; // 'overwrite'

                    // filterableName = item.genLastname + ' ' + item.genFirstName + ' ' + item.contract3Code;
                    // item.filterableName = filterableName;
                    // fullName = item.genLastname + ', ' + item.genFirstName;
                    // item.fullName = fullName;

                    item.wasEdited = true;
                }
                hotels_hotels_Copy.push(item);
            });

            state.hotels_hotels = hotels_hotels_Copy;
            state.hotels_hotels_Filtered = hotels_hotels_Copy;
        }

        if (payload.editorMode === 'create') {
            item = payload.response;

            // filterableName = item.genLastname + ' ' + item.genFirstName + ' ' + item.contract3Code;
            // item.filterableName = filterableName;
            // fullName = item.genLastname + ', ' + item.genFirstName;
            // item.fullName = fullName;

            item.wasEdited = false;

            state.hotels_hotels = state.hotels_hotels.concat(item);
        }


        payload.context.commit('mut_filter_Hotels'); // filter again

    }, // eof mut_call_updateCreateHotel()

    /***************************************************************************
    * mut_call_deleteHotel()
    *
    * Desc: Delete Index from 'index_hotels_hotels_Filtered'.
    * Note: Delete in filtered AND in original Hotel list.
    *
    */
    mut_call_deleteHotel: (state, payload) => {

        let index_hotels_hotels_Filtered = state.hotels_hotels_Filtered.findIndex(i => i.id === payload.id),
            index_hotels_hotels = state.hotels_hotels.findIndex(i => i.id === payload.id);


        if (index_hotels_hotels_Filtered > -1) {
            state.hotels_hotels_Filtered.splice(index_hotels_hotels_Filtered, 1);
        }

        if (index_hotels_hotels > -1) {
            state.hotels_hotels.splice(index_hotels_hotels, 1);
        }

    }, // eof mut_call_deleteHotel()

    /***************************************************************************
    * mut_call_switchActiveStatus()
    *
    * Desc: Switch active status based on backend response.
    * Note: 
    *
    */
    mut_call_switchActiveStatus: (state, payload) => {

        payload.context.commit('mut_call_updateCreateHotel', { response: payload.response, context: payload.context, editorMode: 'update' });

    }, // eo function mut_call_switchActiveStatus()


    /***************************************************************************
    * Mutations: 'Hotels' Hotel Goodies'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_HotelGoodies()
    *
    * Desc: Set
    * Note:
    *
    */
    mut_call_HotelGoodies: (context, payload) => {

        state.hotel_HotelGoodies = payload;

    }, // eof mut_call_HotelGoodies()


    /***************************************************************************
    * mut_call_AddHotelGoodies()
    *
    * Desc: Set
    * Note:
    *
    */
    mut_call_AddHotelGoodies: (context, payload) => {

        state.hotel_HotelGoodies.push(payload)

    }, // eof mut_call_HotelGoodies()




    /***************************************************************************
    * Mutations: 'Hotels' - Set Search/Filter/Term
    ***************************************************************************/
    /***************************************************************************
    * mut_set_filterHotels_filterTerm()
    *
    * Desc: Simply set 'hotel_filterTerm'.
    * Note:
    *
    */
    mut_set_filterHotels_filterTerm: (state, payload) => {

        state.hotels_filterTerm = payload;

    }, // eof mut_set_filterHotels_filterTerm()


    /***************************************************************************
    * mut_set_filterHotel_searchTerm()
    *
    * Desc: Simply set 'hotels_searchTerms'.
    * Note:
    *
    */
    mut_set_filterHotels_searchTerm: (state, payload) => {

        state.hotels_searchTerms = payload;

    }, // eof mut_set_filterHotels_searchTerm()




    /***************************************************************************
    * Mutations: 'Hotels' - Rebuild Filtered Hotels
    ***************************************************************************/
    /***************************************************************************
    * mut_filter_Hotels()
    *
    * Desc: (Re)build 'new' hotels_hotels_Filtered.
    * Note:
    *
    */
    mut_filter_Hotels: (state) => {

        const filterCountry = (hotel) => {
            let applyFilter = false;

            if (state.hotels_searchTerms && state.hotels_searchTerms.country !== '') {
                if (+state.hotels_searchTerms.country === +hotel.idCountry) {
                    applyFilter = true;
                }
            } else {
                applyFilter = true;
            }

            return applyFilter;
        };

        const filterCity = (hotel) => {
            let applyFilter = false;

            if (state.hotels_searchTerms && state.hotels_searchTerms.city !== '') {
                if (state.hotels_searchTerms.city.match(new RegExp(hotel.city, 'i'))) {
                    applyFilter = true;
                }
            } else {
                applyFilter = true;
            }

            return applyFilter;
        };

        const filterShuttle = (hotel) => {
            let applyFilter = false;

            if (state.hotels_searchTerms && state.hotels_searchTerms.shuttle.length > 0) {
                if (state.hotels_searchTerms.shuttle.includes(hotel.shuttleService)) {
                    applyFilter = true;
                }
            } else {
                applyFilter = true;
            }

            return applyFilter;
        };

        /***************************************************************************
        * filterAssociatedAirport()
        *
        * Desc:
        * Note: RegExp(null) does not match anything. Case: associatedAirport is
        * Note: an empty string -> make it null -> no matches.
        *
        */
        const filterAssociatedAirport = (hotel) => {
            let applyFilter = false;

            if (state.hotels_searchTerms && state.hotels_searchTerms.associatedAirport !== '') {
                if (state.hotels_searchTerms.associatedAirport.match(new RegExp(hotel.associatedAirport !== null ? hotel.associatedAirport : null))) {
                    applyFilter = true;
                }
            } else {
                applyFilter = true;
            }

            return applyFilter;
        };

        /***************************************************************************
        * filterStatus()
        *
        * Desc: Filter out with status. (active: true | false)
        * Note: 
        *
        */
        const filterStatus = (hotel) => {
            let applyFilter = false;

            if (state.hotels_searchTerms && state.hotels_searchTerms.status.length > 0) {
                if (state.hotels_searchTerms.status.includes(hotel.active)) {
                    applyFilter = true;
                }
            } else {
                applyFilter = true;
            }

            return applyFilter;
        };

        const filterHotelCost = (hotel) => {
            let applyFilter = false;

            if (state.hotels_searchTerms && state.hotels_searchTerms.minHotelCost !== '' && state.hotels_searchTerms.maxHotelCost !== '') {
                if (+hotel.apiecePrice >= +state.hotels_searchTerms.minHotelCost && +hotel.apiecePrice <= +state.hotels_searchTerms.maxHotelCost) {
                    applyFilter = true;
                }
            } else {
                applyFilter = true;
            }

            return applyFilter;
        };

        state.hotels_hotels_Filtered = state.hotels_hotels.filter(hotel => hotel.hotelName.match(new RegExp(state.hotels_filterTerm, 'i')));
        state.hotels_hotels_Filtered = state.hotels_hotels_Filtered.filter(hotel => filterCountry(hotel));
        state.hotels_hotels_Filtered = state.hotels_hotels_Filtered.filter(hotel => filterCity(hotel));
        state.hotels_hotels_Filtered = state.hotels_hotels_Filtered.filter(hotel => filterShuttle(hotel));
        state.hotels_hotels_Filtered = state.hotels_hotels_Filtered.filter(hotel => filterAssociatedAirport(hotel));
        state.hotels_hotels_Filtered = state.hotels_hotels_Filtered.filter(hotel => filterStatus(hotel));
        state.hotels_hotels_Filtered = state.hotels_hotels_Filtered.filter(hotel => filterHotelCost(hotel));

    }, // eof mut_filter_Hotels()

};



//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Hotels' - Load Hotel(s)
    ***************************************************************************/
    /***************************************************************************
    * Call::'humanresources/config/hotel/';
    *
    * Desc: Call: Get List of Hotels.
    *
    */
    actn_call_getHotels: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.get('/humanresources/config/hotel')
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_set_Hotels', { response: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getHotels()




    /***************************************************************************
    * Actions: 'Hotels' - Updates and Creates Hotel
    ***************************************************************************/
    /***************************************************************************
    * Call::'humanresources/config/hotel/';
    *
    * Desc: Call: Updates and Creates Hotel.
    *
    */
    actn_call_updateCreateHotel: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/humanresources/config/hotel', payload.payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_updateCreateHotel', { response: response.data, editorMode: payload.editorMode, context: context });
                        eventBus.$emit('hotelwasupdatedcreated'); // emit ..
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_updateCreateHotel()

    /***************************************************************************
    * Call::'/humanresources/config/hotel'
    *
    * Desc: Call: Delete Hotel.
    * Note: Payload is 'id' (Hotel Id).
    *
    */
    actn_call_deleteHotel: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/config/hotel/' + payload;


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.delete(url)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_deleteHotel', { id: payload });
                        Vue.prototype.$toasted.global.sdr_app_info({ // inform
                            message: 'Hotel was deleted.'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_deleteHotel()


    /***************************************************************************
    * Call::'humanresources/config/hotel/status/[id]/[active | inactive]'
    *
    * Desc: Call: Switch active/inactive of Hotel.
    * Note: Payload is Hotel object.
    *
    */
    actn_call_switchActiveStatus: (context, payload) => {

        let hdrs = '',
            url = `humanresources/config/hotel/status/${payload.id}/${payload.active === true ? 'active' : 'inactive'}`;


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.get(url)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_switchActiveStatus', { response: response.data, context: context });
                        Vue.prototype.$toasted.global.sdr_app_info({ // inform
                            message: 'Record was updated.'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_switchActiveStatus()


    /***************************************************************************
    * Actions: 'Hotels' - Updates and Creates Hotel Goodies
    ***************************************************************************/
    /***************************************************************************
    * Call::'/humanresources/hotel/goodies'
    *
    * Desc: Call: Get List of Hotel Goodies.
    * Note:
    *
    */
    actn_call_getHotelGoodies: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/humanresources/hotel/goodies')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_HotelGoodies', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getHotelGoodies()


    /***************************************************************************
    * Call::'/humanresources/hotel/goodies'
    *
    * Desc: Call: Get List of Hotel Goodies.
    * Note:
    *
    */
    actn_call_AddHotelGoodies: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.put('/humanresources/hotel/goodies', payload)
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_AddHotelGoodies', response.data);
                        eventBus.$emit('goodywascreated');
                        Vue.prototype.$toasted.global.sdr_app_info({ // inform
                            message: 'Goody created.'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getHotelGoodies()




    /***************************************************************************
    * Actions: 'Hotels' - Search/Filter Terms
    ***************************************************************************/
    /***************************************************************************
    * actn_set_filterHotels_filterTerm()
    *
    * Desc: Set 'filter Terms' and 'refilter'.
    * Note:
    *
    */
    actn_set_filterHotels_filterTerm: (context, payload) => {

        context.commit('mut_set_filterHotels_filterTerm', payload);
        context.commit('mut_filter_Hotels');

    }, // eo function actn_set_filterHotels_filterTerm()


    /***************************************************************************
    * actn_set_filterHotels_searchTerm()
    *
    * Desc: Set 'search Terms' and 'refilter'.
    * Note:
    *
    */
    actn_set_filterHotels_searchTerm: (context, payload) => {

        context.commit('mut_set_filterHotels_searchTerm', payload);
        context.commit('mut_filter_Hotels');

    }, // eo function actn_set_filterHotels_searchTerm()

};



//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};